export default "__VITE_ASSET__bc71f5e8__"